import React, { Component } from 'react'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import {
  createEditorState,
  destroyEditorState,
  addComponentToPage,
  removeComponentFromPage,
  movePageComponent,
  openBrowser,
  closeBrowser,
  selectPageComponent,
  unselectPageComponent,
  updatePageComponentAttribute
} from 'actions/editor'

import { Prompt } from 'router/index'

import ComponentRenderer from 'components/ComponentRenderer'
import ComponentBrowser from 'components/ComponentBrowser'
import ComponentEditor from 'components/ComponentEditor'
import PageComponent from 'components/PageComponent'
import PageComponentControls from 'components/PageComponentControls'
import PageComponentTouchable from 'components/PageComponentTouchable'
import AddArea from 'components/AddArea'
import EditorCanvas from 'components/EditorCanvas'
import Viewport from 'components/Viewport'

const Main = Styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
`

const Page = Styled.div`
  background-color: #fff;
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
  margin: 0 0 2.25rem 0;
`

class Editor extends Component {
  componentDidMount() {
    this.props.createEditorState()
  }

  componentWillUnmount() {
    this.props.destroyEditorState()
  }

  handleCanvasClick = () => {
    if (this.props.isBrowserOpen) {
      this.props.closeBrowser()
    }

    if (this.props.isEditorOpen) {
      this.props.unselectPageComponent()
    }
  }

  handleClickPageComponent = (pageComponent) => {
    if (this.props.isEditorOpen) return
    if (this.props.isBrowserOpen) return

    this.props.selectPageComponent(pageComponent)
  }

  handleClickPageComponentAdd = (insertAtIndex) => {
    if (this.props.isEditorOpen) return
    if (this.props.isBrowserOpen) return

    this.props.openBrowser(insertAtIndex)
  }

  render() {
    if (this.props.loading) {
      return null
    }

    return (
      <Main>
        <ComponentBrowser
          isOpen={this.props.isBrowserOpen}
          theme={this.props.theme}
          components={this.props.components}
          onAddComponent={this.props.addComponentToPage}
          onClose={this.props.closeBrowser}
        />

        <EditorCanvas
          isRightSidebarOpen={this.props.isEditorOpen}
          isLeftSidebarOpen={this.props.isBrowserOpen}
          onCanvasClick={this.handleCanvasClick}
        >
          <Page>
            {this.props.pageComponents.map((pageComponent, index) => (
              <PageComponent
                key={pageComponent._cid}
                isDisabled={this.props.pageComponent && this.props.pageComponent._cid !== pageComponent._cid}
                isOpen={this.props.pageComponent && this.props.pageComponent._cid === pageComponent._cid}
              >
                <PageComponentControls
                  data-selector="page-component-controls"
                  onEdit={() => this.props.selectPageComponent(pageComponent)}
                  onRemove={() => this.props.removeComponentFromPage(pageComponent._cid)}
                  onMove={position => this.props.movePageComponent(pageComponent._cid, position)}
                />

                <Viewport
                  containerId="editor-canvas"
                  device={this.props.device}
                >
                  <ComponentRenderer
                    theme={this.props.theme}
                    pageComponent={pageComponent}
                  />
                </Viewport>

                <PageComponentTouchable
                  isOpen={this.props.pageComponent && this.props.pageComponent._cid === pageComponent._cid}
                  isEditorOpen={this.props.isEditorOpen}
                  isBrowserOpen={this.props.isBrowserOpen}
                  onClick={() => this.handleClickPageComponent(pageComponent)}
                  onClickAdd={_index => this.handleClickPageComponentAdd(_index + index)}
                />
              </PageComponent>
            ))}
          </Page>

          <AddArea onClick={() => this.props.openBrowser(this.props.pageComponents.length)} />

          {/* hack size for add area */}
          <Viewport
            containerId="editor-canvas"
            device={this.props.device}
          />
        </EditorCanvas>

        <ComponentEditor
          isOpen={this.props.isEditorOpen}
          pageComponent={this.props.pageComponent}
          onAttributeChange={this.props.updatePageComponentAttribute}
          onClose={this.props.unselectPageComponent}
        />

        <Prompt
          when={this.props.hasUnsavedChanges}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      </Main>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createEditorState: () => dispatch(createEditorState()),
    destroyEditorState: () => dispatch(destroyEditorState()),
    addComponentToPage: component => dispatch(addComponentToPage(component)),
    removeComponentFromPage: pageComponentClientId => dispatch(removeComponentFromPage(pageComponentClientId)),
    movePageComponent: (pageComponentClientId, position) => dispatch(movePageComponent(pageComponentClientId, position)),
    openBrowser: insertAtIndex => dispatch(openBrowser(insertAtIndex)),
    closeBrowser: () => dispatch(closeBrowser()),
    selectPageComponent: pageComponent => dispatch(selectPageComponent(pageComponent)),
    unselectPageComponent: pageComponent => dispatch(unselectPageComponent(pageComponent)),
    updatePageComponentAttribute: attribute => dispatch(updatePageComponentAttribute(attribute))
  }
}

const mapStateToProps = (state) => {
  return {
    project: state.project.project,
    components: state.project.components,
    device: state.project.device,
    theme: state.project.theme,

    loading: state.project.loading,
    isBrowserOpen: state.project.isBrowserOpen,
    isEditorOpen: state.project.isEditorOpen,
    hasUnsavedChanges: state.project.hasUnsavedChanges,
    pageComponents: state.project.pageComponents,
    pageComponent: state.project.pageComponent

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor)



// WEBPACK FOOTER //
// ./src/components/Editor/index.js